import { useState, useCallback } from "react";

type Status = "idle" | "loading" | "granted" | "denied";
type Coords = { lat: number; lng: number } | null;

export const useGeolocation = () => {
  const [userLocation, setUserLocation] = useState<Coords>(null);
  const [status, setStatus] = useState<Status>("idle");

  const request = useCallback(
    (onDenied?: () => void): Promise<Coords> =>
      new Promise((resolve) => {
        if (!navigator.geolocation) {
          setStatus("denied");
          onDenied?.();
          return resolve(null);
        }
        setStatus("loading");
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
            setUserLocation(loc);
            setStatus("granted");
            resolve(loc);
          },
          () => {
            setStatus("denied");
            onDenied?.();
            resolve(null);
          },
          { enableHighAccuracy: false, timeout: 10000, maximumAge: 60000 }
        );
      }),
    []
  );

  return { userLocation, status, request };
};